import { ContactPoint } from './contact-point.model';

export class AccountDetail {

    name: string;
    oemCustomerId: string;
    customerCategory: string;
    type: string;
    logo: string;
    contactPoints: ContactPoint;

    constructor(name: string,
        oemCustomerId: string,
        customerCategory: string,
        type: string,
        logo: string,
        contactPoints: ContactPoint) {
        this.name = name;
        this.oemCustomerId = oemCustomerId;
        this.customerCategory = customerCategory;
        this.type = type;
        this.logo = logo;
        this.contactPoints = contactPoints;
    }

    public setContactPoints(contactPoints: ContactPoint) {
        this.contactPoints = contactPoints;
    }


}
